// Firebase requires an email on every password account. Patients who register
// with a username sign in through this domain: we own it, it never delivers
// mail, and it must never be shown to a patient.
export const USERNAME_AUTH_DOMAIN = "usernames.vance.invalid";
